import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';

import {reducers} from './reducers';

// const myCustomLogger = store => next => action => {
//   console.groupCollapsed(`Action: ${action.type}`);
//   console.log('Previous state:', store.getState());
//   console.log(`Payload:`, action.payload);
//   const result = next(action);
//   console.log('Next state:', store.getState());
//   // console.log('Next cartItems:', store.getState().cartState.cartItems);
//   console.groupEnd();
//   return result;
// };

const store = createStore(
  reducers,
  composeWithDevTools(
    applyMiddleware(
      thunk,
      // myCustomLogger
    )
  )
);

export default store;

